import AddressRenderer from './AddressRenderer';
import BooleanRenderer from './BooleanRenderer';
import ClientRenderer from './ClientRenderer';
import ContactRenderer from './ContactRenderer';
import CouponCategoryRenderer from './CouponCategoryRenderer';
import CurrencyRenderer from './CurrencyRenderer';
import DateRenderer from './DateRenderer';
import DateTimeRenderer from './DateTimeRenderer';
import FulfilmentLocationRenderer from './FulfilmentLocationRenderer';
import NumberRenderer from './NumberRenderer';
import OrderRenderer from './OrderRenderer';
import OrganisationRenderer from './OrganisationRenderer';
import PaymentMethodRenderer from './PaymentMethodRenderer';
import PaymentMethodCodeRenderer from './PaymentMethodCodeRenderer';
import PaymentProviderRenderer from './PaymentProviderRenderer';
import ShippingMethodRenderer from './ShippingMethodRenderer';
import SuggestionRenderer from './SuggestionRenderer';
import TextRenderer from './TextRenderer';
import UserRenderer from './UserRenderer';

export default {
  address: AddressRenderer,
  boolean: BooleanRenderer,
  client: ClientRenderer,
  contact: ContactRenderer,
  couponCategory: CouponCategoryRenderer,
  currency: CurrencyRenderer,
  date: DateRenderer,
  datetime: DateTimeRenderer,
  default: SuggestionRenderer,
  fulfilmentLocation: FulfilmentLocationRenderer,
  number: NumberRenderer,
  order: OrderRenderer,
  organisation: OrganisationRenderer,
  paymentMethod: PaymentMethodRenderer,
  paymentMethodCode: PaymentMethodCodeRenderer,
  paymentProvider: PaymentProviderRenderer,
  search: TextRenderer,
  shippingMethod: ShippingMethodRenderer,
  suggestion: SuggestionRenderer,
  text: TextRenderer,
  user: UserRenderer,
};
